import { render } from "./FirstBodyTemplate.vue?vue&type=template&id=208d0c9a&scoped=true"
import script from "./FirstBodyTemplate.vue?vue&type=script&lang=js"
export * from "./FirstBodyTemplate.vue?vue&type=script&lang=js"

import "./FirstBodyTemplate.vue?vue&type=style&index=0&id=208d0c9a&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208d0c9a"]])

export default __exports__